var map = {
	"./17-cn.webp": 1307,
	"./17.webp": 1308,
	"./27-cn.webp": 1309,
	"./27.webp": 1310,
	"./7-cn.webp": 1311,
	"./7.webp": 1312,
	"./angpao-bg-mobile.jpg": 1313,
	"./angpao-bg.jpg": 1314,
	"./angpao-cn.webp": 1315,
	"./angpao.webp": 1316,
	"./button.png": 1317,
	"./close-eye.png": 1318,
	"./coin-1.png": 1319,
	"./coin.png": 1320,
	"./ketupak-open.png": 1321,
	"./ketupak.png": 1322,
	"./ketupak_ribbon.png": 1323,
	"./rain-1.png": 1324,
	"./rain-2.png": 1325,
	"./rain-3.png": 1326,
	"./raya-bg-mobile.png": 1327,
	"./raya-bg.png": 1328,
	"./shine.png": 1329,
	"./star-1.png": 1330,
	"./star-2.png": 1331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 440;